<template>
  <div
    class="day-event"
    :style="defaultStyle"
  >
    <div class="img">
      <i
        v-if="type === 'Holiday'"
        class="hi hi-icon hi-20 hi-time-off"
      />
      <img
        v-else
        :src="avatar"
      />
    </div>
    <div class="event-details">
      <span class="name">{{ userRealName }}</span>
      <span class="event-details">{{ eventDetails }}</span>
    </div>
    <div class="all-day">
      <span v-if="allDay">All day</span>
    </div>
    <div
      v-if="shiftSpillover"
      class="d-flex align-items-center"
    >
      <i
        v-tooltip="{ placement: 'left' }"
        class="hi-right"
        title="This shift continues into the next day"
      />
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import tooltipDirective from '~/directives/tooltip';

// Rendered inside @fullcalendar/vue3's mini `createApp`, which doesn't inherit the host app's
// context — no `$page` (mapInertiaProps would crash) and no global directives. `timeZone` comes in
// as a prop from the host and the tooltip directive is registered locally.
export default {
  name: 'DayViewEvent',
  directives: { tooltip: tooltipDirective },
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
    timeZone: {
      type: String,
      default: '',
    },
  },
  computed: {
    eventDetails() {
      return this.type === 'Shift' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
